import { Button, ListBox } from '@flos/react-ui';
import usePageNavigation from '../../../hooks/usePageNavigation';
import WizardPagetemplate from '../../../templates/WizardPagetemplate';
import { useSetRecoilState } from 'recoil';
import { opcInfoAtom } from '../../../recoil/atoms/opcInfoAtom';
import usePrhHouseOPC from '../../../hooks/usePrhHouseOPC';
import { useState } from 'react';
import CallMeModal from '../../../shared_components/CallMeModal/CallMeModal';
import { useHippoText } from '../../../hooks/useHippoText';
import useOpcJob from '../../../hooks/useOpcJob';
import { getCurrencyString } from '../../../utils/currencyUtil';
import AttributeTitle from './AttributeTitle';

const formatFieldValue = (fieldValue: string | boolean | number, fieldName: string): string => {
    if (fieldName.toLocaleLowerCase().includes('area') && typeof fieldValue === 'number') {
        return `${fieldValue} m2`;
    }
    if (typeof fieldValue === 'boolean') {
        return fieldValue ? 'Ja' : 'Nej';
    }
    if (typeof fieldValue === 'number') {
        if (fieldName === 'firstRiskSum') {
            return getCurrencyString(fieldValue, ' kr.');
        }
        return fieldValue.toString();
    }

    return fieldValue;
};
const PrhEditAttributePage = ({
    setIsOpenModal
}: {
    setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { goBackToDetailsPage } = usePageNavigation();
    const setOpcInfo = useSetRecoilState(opcInfoAtom);
    const { attributesConfig } = usePrhHouseOPC();
    const [showCallMeModal, setShowCallMeModal] = useState(false);
    const closeModal = (): void => {
        setShowCallMeModal(false);
    };
    const { withdrawCurrentOPCShoppingBasketIfNotExisting } = useOpcJob();

    const handleGoBack = async (): Promise<void> => {
        await withdrawCurrentOPCShoppingBasketIfNotExisting();
        goBackToDetailsPage();
    };

    return (
        <WizardPagetemplate showGiftCertificateBanner={false} hidePrevious hideNext>
            <div className="u-display-flex u-flex-row u-flex-items-center u-gap-x-2 u-spacing-stack-m">
                <Button
                    theme="secondary"
                    size="medium"
                    iconShape="arrow-left"
                    onClick={() => {
                        void handleGoBack();
                    }}
                />
                <span>Tilbage</span>
            </div>
            <h3>Tilpas dine detaljer</h3>
            {attributesConfig.map((attribute) => {
                if (attribute.editable) {
                    return (
                        <ListBox
                            className="u-spacing-stack-m"
                            role="listitem"
                            key={attribute.name}
                            title={
                                <AttributeTitle attributeConfig={attribute} key={attribute.name} />
                            }
                            subtitle={formatFieldValue(attribute.value, attribute.name)}
                            action={
                                <Button
                                    theme="secondary"
                                    onClick={() => {
                                        setIsOpenModal(true);
                                        setOpcInfo((prev) => {
                                            return { ...prev, attribute: attribute.opcAttribute };
                                        });
                                    }}
                                >
                                    Tilpas
                                </Button>
                            }
                        />
                    );
                }
                if (attribute.willTriggerCallMeModal) {
                    return (
                        <ListBox
                            className="u-spacing-stack-m"
                            role="listitem"
                            key={attribute.name}
                            title={
                                <AttributeTitle attributeConfig={attribute} key={attribute.name} />
                            }
                            subtitle={formatFieldValue(attribute.value, attribute.name)}
                            action={
                                <Button
                                    theme="secondary"
                                    onClick={() => {
                                        setShowCallMeModal(true);
                                    }}
                                >
                                    Tilpas
                                </Button>
                            }
                        />
                    );
                }
                return (
                    <ListBox
                        className="u-spacing-stack-m"
                        role="listitem"
                        key={attribute.name}
                        title={<AttributeTitle attributeConfig={attribute} key={attribute.name} />}
                        subtitle={formatFieldValue(attribute.value, attribute.name)}
                        action={'Kan ikke ændres'}
                    />
                );
            })}

            {showCallMeModal && (
                <CallMeModal
                    showModal={showCallMeModal}
                    closeModal={closeModal}
                    activityCode="dss_call_request"
                    isDefault={false}
                    title={getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-HEADER')}
                    subdescription={getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-SUBHEADER')}
                    description={getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-BOOK-CALL-SUBHEADER')}
                />
            )}
        </WizardPagetemplate>
    );
};
export default PrhEditAttributePage;
